import { useQuery } from '@tanstack/react-query';

import { api } from '../api/client';

export interface InventorySource {
  plugin_id: string;
  label: string;
}

/**
 * Плагины, поставляющие инвентарь (capability `inventory_source`, #276).
 *
 * По наличию источника интерфейс решает, показывать ли раздел «Свод инвентаря».
 * До этого пункт меню был всегда, и на инсталляции без такого плагина это был
 * пустой раздел, существующий сам по себе: пользователь видел функциональность,
 * которой у него нет, и не мог понять, сломано это или так задумано.
 *
 * Развилка идёт по capability, а не по имени вендора — FleetDM сегодня, любой
 * другой источник завтра. Тот же приём уже применён к finding_enricher
 * (`GET /plugins/capabilities/finding-enrichers`).
 */
export function useInventorySources() {
  return useQuery({
    queryKey: ['plugin-capabilities', 'inventory-sources'],
    queryFn: async (): Promise<InventorySource[]> => {
      const response = await api.get('/plugins/capabilities/inventory-sources');
      return response.data?.data?.sources ?? [];
    },
    // Состав установленных плагинов меняется руками админа, а не сам по себе:
    // перезапрашивать его на каждом переходе между страницами незачем.
    staleTime: 5 * 60 * 1000,
  });
}
